import firebase from "datastore/database";

export async function add(businessUid, data) {
  return firebase
    .firestore()
    .collection(`business-customers/business/${businessUid}`)
    .add(data);
}

export async function update(businessUid, uid, data) {
  return firebase
    .firestore()
    .collection(`business-customers/business/${businessUid}`)
    .doc(uid)
    .update(data);
}
